import {SoundsService} from "../../../services/SoundsService";
import {sounds} from "../../../sounds/sound";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";
import {config} from "../../../config";

function NavBarIco({route, className}) {

    const {tutorial} = useTypedSelector(state => state.auth);
    const {setRoute, setTutorial} = useActions();

    const clickOnMenu = function (route) {
        SoundsService.playSound(sounds.menu_open_popup());
        setRoute(route);

        // Tutorial
        if (route === 'deck' && tutorial.isActive && tutorial.step === 'ClickBuy120') {
            tutorial.step = 'ClickAdd130';
            setTutorial(tutorial);
        }

        if (route === 'offers' && tutorial.isActive && tutorial.step === 'ClickOffers95') {
            tutorial.step = 'ClickShop100';

            setTutorial(tutorial);
        }

    }
    let additionalClasses = '';
    let doRoute = true;
    // ClickBuy120
    if (
        (tutorial.step === 'ClickOffers95' && route !== 'offers')
        ||  (tutorial.step === 'ClickBuy120' && route !== 'deck')
    ) {
        additionalClasses = ' map-ico-gray';
        doRoute = false;
    }
    if (
        (tutorial.step === 'ClickOffers95' && route === 'offers')
        ||  (tutorial.step === 'ClickBuy120' && route === 'deck')
    ) {
        additionalClasses = ' defaultButtonAnimation_2_5';
    }
    // end

    return (<div className={"m_n_button " + className + additionalClasses} onClick={() => {
        if (doRoute) {
            if(route === 'gem_shop' && !config.isNutaku) {
                window.open("https://www.patreon.com/c/depravedworld", "_blank");
                return;
            }

            clickOnMenu(route);
        }
    }}>
    </div>)
}

export default NavBarIco;